import React from "react";

export const CateChismSvg = ({size = 20, ...props}) => {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 68 68"
            xmlns="http://www.w3.org/2000/svg"
            {...props}>
            <path
                d="M42.458 18.086l-2.374 3.834-4.254-.398-2.212 3.55 4.255.397-6.196 10.017 3.829.352 6.2-10.005 4.255.398 2.207-3.56-4.255-.398 2.364-3.83-3.819-.357z"
                fill="currentColor"
            />
            <path
                d="M60.873 10.554C31.375 9.11 34.2 9.259 29.123 9.002c-.924-.041-2.048.53-2.543 1.292L1.246 49.386c-.698 1.07.022 1.585 3.043 7.432.446.859-1.546.478 32.885 2.175 2.441.126 5.466-1.384 6.866-3.487L66.348 21.08c.697-1.043.84-2.086.405-2.925l-3.19-6.196c-.367-.707-1.257-1.328-2.69-1.404zm1.572 3.9c-10.166 15.684-5.154 7.955-22.313 34.417-1.172 1.821-3.91 3.212-6.11 3.103-6.968-.344-2.477-.122-24.276-1.183l26.31-40.597 24.77 1.214c2.085.09 2.66 1.445 1.619 3.046zM37.257 57.138C3.84 55.628 5.942 55.75 5.884 55.637l-1.62-3.122c4.82.208-.453-.026 29.68 1.324 2.858.107 6.331-1.707 7.78-3.963 2.553-3.94-.888 1.37 21.89-33.742l1.468 2.855c.131.253-.12.789-.312 1.065L42.458 54.497c-.99 1.524-3.51 2.74-5.2 2.64z"
                fill="currentColor"
            />
            <path
                d="M19 48.332L32.168 49 33 47.673 19.817 47 19 48.332zM17 43.637L40.128 45 41 43.363 17.872 42 17 43.637zM36 56a466.934 466.934 0 00-29-1c9.663.618 19.328.948 29 1zM7 54c9.44.567 28.146 1.085 28.093.98 1.336.046 2.741.08 3.907-.735-2.337 1.443-4.314-.191-32-.245zM41.744 51.378A1033.325 1033.325 0 0062.67 19.166a1033.089 1033.089 0 00-20.926 32.212zM62.725 21.167a932.622 932.622 0 00-19.99 30.77 908.662 908.662 0 0019.99-30.77z"
                fill="currentColor"
            />
        </svg>
    )
}